// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.Provinces[data-v-3a9e2d99] {\n  height: 360px;\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
